import React from "react";
import { Form } from "react-bootstrap";
import { RequiredMark } from "../FormFields";

interface Option {
  value: string | number;
  label: string;
}

interface Props {
  controlId: string;
  label: string;
  placeholder: string;
  value: string | number | undefined;
  options: Option[];
  onChange: (value: string) => void;
  className?: string;
}

export function LabeledSelect({
  controlId,
  label,
  placeholder,
  value,
  options,
  onChange,
  className = "mb-3",
}: Props) {
  return (
    <Form.Group controlId={controlId} className={className}>
      <Form.Label>
        {label} <RequiredMark />
      </Form.Label>
      <Form.Select size="sm" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value={undefined}>{placeholder}</option>
        {options.map((option) => (
          <option key={`${controlId}-${option.value}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
